// Wrapper Component for the Badge Component
import { Badge as MantineBadge, MantineSize } from '@mantine/core';
import { ReactElement } from 'react';

// Link to Mantine Badge Component:  https://mantine.dev/core/badge/
interface Props {
    bgColor: string,
    color: string,
    text: string,
    size: MantineSize,
    borderColor?: string,
}
export function Badge({ bgColor, color, text, size, borderColor = '#9747FF' } : Props): ReactElement {
  return (
    <MantineBadge bg={bgColor} c={color} size={size} style={{ textTransform: 'none', fontFamily: 'Mabry' }} sx={{ borderTop: `1px solid ${borderColor}`, borderColor }}>
      {text}
    </MantineBadge>
  );
}
